import { render } from "./addHotel.vue?vue&type=template&id=5c98b8a6&scoped=true"
import script from "./addHotel.vue?vue&type=script&lang=js"
export * from "./addHotel.vue?vue&type=script&lang=js"

import "./addHotel.vue?vue&type=style&index=0&id=5c98b8a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c98b8a6"]])

export default __exports__